import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import { actionTypes, useStateValue } from '../../store';
import Button from '@mui/material/Button';
import Header from '../BaseComponents/Header';
import FotterMain from '../BaseComponents/FotterMain';
import MenuItem from '@mui/material/MenuItem';
import { useLocation, useNavigate } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import { addCustomerBillingAddress, getCityList, getCountryList, getStateList, saveCustomerAddress } from '../../networkCalls';

const addressType = [
    {
        value: 'Home',
        label: 'Home',
    },
    {
        value: 'Office',
        label: 'Office',
    },
];

const validationSchema = yup.object({
    addressLine1: yup
        .string('Enter your address')
        .required('Address is required'),
    zipcode: yup
        .string('Enter your Pincode ')
        .min(6, 'Min 6 Digit')
        .max(6, 'Max 6 Digit')
        .matches(/^[0-9]+$/, "Must be only digits")
        .required('Pincode is required'),
    addressType: yup
        .string('Enter your Address Type ')
        .required('Address Type is required'),
    gst: yup
        .string('Enter your gst ')
        .min(13, '15 Digit GST No')
        .max(13, '15 Digit GST No')
        .notRequired(),
    businessName: yup
        .string('Enter your business name')
        .notRequired(),
});


const UpdateBillingAddress = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [{ token, huid }, dispatch] = useStateValue();
    const [errMessage, setErrMessage] = useState('');
    const [susMessage, setSusMessage] = useState('');
    const [haveGST, setHaveGST] = useState(false);
    const haveGSTChange = (event) => {
        setHaveGST(event.target.checked);
    };
    const [countryList, setCountryList] = useState([]);
    const pullCountryList = () => {
        getCountryList().then((res) => {
            switch (res.data.status) {
                case 1:
                    setCountryList(res.data.countryList);
                    return true;
                case 0:
                    break;

                default:
                    return;
            }
        })
    }

    const [stateList, setStateList] = useState([]);
    const pullStateList = (value) => {
        var data = new FormData();
        data.append('countryId', value);
        getStateList(data).then((res) => {
            switch (res.data.status) {
                case 1:
                    setStateList(res.data.stateList);
                    return true;
                case 0:
                    break;
                default:
                    return;
            }
        })
    }

    const [cityList, setCityList] = React.useState([]);
    const pullCityList = (value) => {
        var data = new FormData();
        data.append('stateId', value);
        getCityList(data).then((res) => {
            switch (res.data.status) {
                case 1:
                    setCityList(res.data.cityList);
                    return true;
                case 0:
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        pullCountryList();
    }, [token, huid]);



    const [country, setCountry] = useState('');
    const countryChange = (e, value) => {
        setCountry(value?.id)
        pullStateList(value?.id)
    };
    const [state, setState] = useState('');
    const [stateCode, setStateCode] = useState('');
    const stateChange = (e, value) => {
        setState(value?.id)
        setStateCode(value?.stateCode)

        setCity('')
        if(value?.id!=undefined){
            //console.log('hi varun')
            pullCityList(value?.id)
        }
    };
    const [city, setCity] = useState('');
    const cityChange = (e, value) => {
        setCity(value?.id);
    };

    const formik = useFormik({
        initialValues: {
            addressLine1: '',
            addressLine2: '',
            zipcode: '',
            addressType: '',
            gst: '',
            businessName: ''
        },

        validationSchema: validationSchema,
        onSubmit: (values) => {
            //alert(JSON.stringify(values, null, 2));
            var data = new FormData();
            data.append('customerId', huid);
            // data.append('XAuth', token);
            data.append('addressLine1', values.addressLine1);
            data.append('addressLine2', values.addressLine2);
            data.append('country', country);
            data.append('state', state);
            data.append('city', city);
            data.append('haveGST', haveGST);
            data.append('zipcode', values.zipcode);
            data.append('addressType', values.addressType);
            data.append('gstNo', haveGST ? stateCode + values.gst : '');
            data.append('businessName', haveGST ? values.businessName : '');
            // for (var pair of data.entries()) {
            //     console.log(pair[0] + ', ' + pair[1]);
            // }
            addCustomerBillingAddress(data).then((res) => {
                switch (res.data.status) {
                    case 1:
                        setErrMessage('');
                        setSusMessage(res.data.msz);
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        if(location.state.pageref=='checkout'){
                            navigate("/checkout");
                        }
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    case 2:
                        break;
                    default:
                        return;
                }
            })
        },
    });
    useEffect(() => {
        setCityList([]);
        setCity('')
        cityList.length = 0;
    }, [state]);

    return (
        <>
            <Header />

            <div className='innerpagebg pt-5 pb-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-9 text-left m-auto'>
                            <div className="d-flex align-items-center">
                                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>Add Billing</span> <span className='txtdgray'>Address</span>
                                </h4>
                                <div className="ms-auto">
                                    <Button variant="text" onClick={() => navigate(-1)} size="medium" className='d-block mt-3'>
                                        BACK
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container mt-3'>
                    <div className='row'>
                        <div className='col-lg-9 col-md-12 col-12 m-auto'>
                            {errMessage ? <><Alert severity="error">{errMessage}</Alert></> : null}
                            {susMessage ? <><Alert severity="success">{susMessage}</Alert></> : null}
                            <div className='card p-4 mb-3'>
                                <form
                                    onSubmit={formik.handleSubmit}
                                    autoComplete="off"
                                >
                                    <div className="d-flex">
                                        <div>
                                            <label className="text-uppercase fw-bold">Billing Information</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-12">
                                        <hr />
                                    </div>
                                    <div className="row">
                                        <div className='col-lg-12  col-12'>
                                            <TextField

                                                className='mb-4 w-100'
                                                variant="standard"
                                                id="addressLine1"
                                                name="addressLine1"
                                                label="Address Line 1 *"
                                                type="text"
                                                value={formik.values.addressLine1}
                                                onChange={formik.handleChange}
                                                error={formik.touched.addressLine1 && Boolean(formik.errors.addressLine1)}
                                                helperText={formik.touched.addressLine1 && formik.errors.addressLine1}
                                            />
                                        </div>
                                        <div className='col-lg-12 col-12'>
                                            <TextField

                                                className='mb-4 w-100'
                                                variant="standard"
                                                id="addressLine2"
                                                name="addressLine2"
                                                label="Address  Line 2"
                                                type="text"
                                                value={formik.values.addressLine2}
                                                onChange={formik.handleChange}
                                                error={formik.touched.addressLine2 && Boolean(formik.errors.addressLine2)}
                                                helperText={formik.touched.addressLine2 && formik.errors.addressLine2}
                                            />
                                        </div>
                                        <div className='col-lg-4 col-md-4 col-12'>
                                            <Autocomplete
                                                disablePortal
                                                id="country"
                                                className='mb-4'
                                                name="country"
                                                options={countryList}
                                                onChange={countryChange}
                                                sx={{ width: '100%' }}
                                                renderInput={(params) => <TextField required variant="standard" {...params} label="Select Country" />}
                                            />
                                        </div>
                                        <div className='col-lg-4 col-md-4 col-12'>
                                            <Autocomplete
                                                disablePortal
                                                id="state"
                                                className='mb-4'
                                                name="state"
                                                options={stateList}
                                                onChange={stateChange}
                                                sx={{ width: '100%' }}
                                                renderInput={(params) => <TextField required variant="standard" {...params} label="Select State" />}
                                            />
                                        </div>
                                        <div className='col-lg-4 col-md-4 col-12'>
                                            <Autocomplete
                                                disablePortal
                                                className='mb-4'
                                                id="city"
                                                name="city"
                                                options={cityList}
                                                onChange={cityChange}
                                                sx={{ width: '100%' }}
                                                renderInput={(params) => <TextField required variant="standard" {...params} label="Select City" />}
                                            />
                                        </div>
                                        <div className='col-lg-6 col-md-4 col-12'>
                                            <TextField
                                                className='mb-4 w-100'
                                                variant="standard"
                                                id="zipcode"
                                                name="zipcode"
                                                inputProps={{
                                                    maxLength: 6
                                                }}
                                                label="Pincode *"
                                                type="text"
                                                value={formik.values.zipcode}
                                                onChange={formik.handleChange}
                                                error={formik.touched.zipcode && Boolean(formik.errors.zipcode)}
                                                helperText={formik.touched.zipcode && formik.errors.zipcode}
                                            />
                                        </div>
                                        <div className='col-lg-6 col-md-4 col-12'>
                                            <TextField
                                                id="addressType"
                                                className='w-100 mb-4'
                                                select
                                                label="Type of Address *"
                                                name="addressType"
                                                variant="standard"
                                                value={formik.values.addressType}
                                                onChange={formik.handleChange}
                                                error={formik.touched.addressType && Boolean(formik.errors.addressType)}
                                                helperText={formik.touched.addressType && formik.errors.addressType}
                                            >
                                                {addressType?.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>
                                        <div className="col-md-12 col-12">
                                            <hr />
                                        </div>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <FormGroup  >
                                                    <FormControlLabel className=''
                                                        control={<Checkbox className='' checked={haveGST}
                                                            onChange={haveGSTChange} />} label="Have GST" />
                                                </FormGroup>
                                            </div>
                                        </div>
                                        {haveGST ? <><div className="d-flex mt-2">
                                            <div>
                                                <label className="text-uppercase fw-bold mb-2">GST Information</label>
                                            </div>

                                        </div>
                                            <div className='col-12'>
                                                <p>I am solely responsible for entering the correct GSTIN Number. I also understand that any errors in submitting the wrong GTIN number may lead to delay/hold in order processing.</p>
                                            </div>
                                            <div className='col-lg-6 col-md-4 col-12'>
                                                <div className='d-flex'>
                                                    
                                                    <TextField
                                                    className='mb-4 w-100'
                                                    variant="standard"
                                                    id="gst"
                                                    required={haveGST?true:false}
                                                    name="gst"
                                                    label="GST  No"
                                                    type="text"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start" className='me-0'>{stateCode}</InputAdornment>
                                                        )
                                                    }}
                                                    inputProps={{
                                                        maxLength: 13
                                                    }}
                                                    value={formik.values.gst}
                                                    onChange={formik.handleChange}
                                                    error={formik.touched.gst && Boolean(formik.errors.gst)}
                                                    helperText={formik.touched.gst && formik.errors.gst}
                                                />
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-4 col-12'>
                                                <TextField
                                                    className='mb-4 w-100'
                                                    variant="standard"
                                                    id="businessName"
                                                    name="businessName"
                                                    required={haveGST?true:false}
                                                    label="Business Name"
                                                    type="text"
                                                    value={formik.values.businessName}
                                                    onChange={formik.handleChange}
                                                    error={formik.touched.businessName && Boolean(formik.errors.businessName)}
                                                    helperText={formik.touched.businessName && formik.errors.businessName}
                                                />
                                            </div></> : <></>}
                                        <div className="col-lg-12 col-12 mt-4">
                                            <div className="relative w-full mb-3">
                                                <Button color="error" variant="contained" className='w-100' type="submit">
                                                    ADD BILLING ADDRESS
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FotterMain />
        </>
    )
}

export default UpdateBillingAddress